// Toast global autossuficiente (sem store externo / sem MUI). `notify(msg)`
// pode ser chamado de qualquer lugar; o NotifyComp (montado no AppLayout)
// escuta e exibe. Estilo em theme/ui.css (.ueb-toast*), tema-aware.
import { useEffect, useState } from 'react';

const listeners = new Set();
let contador = 0;

export function notify(title) {
    if (!title) return;
    const t = { id: ++contador, title: String(title) };
    listeners.forEach((fn) => fn(t));
}

export default function NotifyComp() {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        const adicionar = (t) => {
            setToasts((prev) => [...prev, t]);
            setTimeout(() => setToasts((prev) => prev.filter((x) => x.id !== t.id)), 3400);
        };
        listeners.add(adicionar);
        return () => listeners.delete(adicionar);
    }, []);

    if (!toasts.length) return null;
    return (
        <div className="ueb-toasts" role="status" aria-live="polite">
            {toasts.map((t) => (
                <div key={t.id} className="ueb-toast">{t.title}</div>
            ))}
        </div>
    );
}
